"use client";

import { useEffect, useState } from "react";
import Image from "next/image";
import fireIcon from "@/assets/svgs/fireIcon.svg";
import brands from "./brands.json";
import "./SoldInfo.css";

export default function SoldInfo({ brand, hideAfter = 300 }) {
  const count = brands[brand];
  const shouldRender = count && count >= 100; // mindestens 100 Verkäufe?

  /* Hooks dürfen niemals bedingt aufgerufen werden  */
  const [isHidden, setIsHidden] = useState(false);

  /* Effekt registrieren wir nur, wenn wir auch etwas anzeigen */
  useEffect(() => {
    if (!shouldRender) return; // keine Event-Listener nötig
    const onScroll = () => setIsHidden(window.pageYOffset > hideAfter);
    onScroll(); // sofort prüfen
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [hideAfter, shouldRender]);

  /* Jetzt erst entscheiden, ob wir rendern */
  if (!shouldRender) return null;

  return (
    <div className={`Sold-wrapper ${isHidden ? "hidden" : ""}`}>
      <div className="Sold-top">
        <Image src={fireIcon} className="Sold-fire-icon" alt="Feuer-Icon" />
        <p className="Sold-headline">Dein {brand} ist gefragt!</p>
      </div>
      <p className="Sold-text">
        Wir haben {count} <strong>{brand}-Fahrzeuge</strong> im letzten Monat verkauft.
      </p>
    </div>
  );
}
